import { Button } from '@symphony-ui/uitoolkit-components';
import { NewFiniteTableContext } from 'components/custom-table/TableContext';
import DownloadContext from 'contexts/DownloadContext';
import ApiServerRequest from 'models/ApiServerRequest';
import * as React from 'react';
import { sendFetchError } from 'utils/messageUtils';
const CompanyMergeButton = ({ companies, setCompanies }) => {
    const { apiFetchJson } = React.useContext(DownloadContext);
    const { resetRowSelection, selection } = React.useContext(NewFiniteTableContext);
    const [isLoading, setLoading] = React.useState(false);
    const disabled = React.useMemo(() => selection !== undefined && selection.length < 2, [selection]);
    const saveMerge = React.useCallback(async () => {
        if (selection !== undefined && selection.length > 1) {
            const idSelections = selection.map((t) => t.id).filter(i => i !== undefined);
            const idSelection = idSelections.join(',');
            resetRowSelection();
            setLoading(true);
            const formData = new FormData();
            formData.append('ids', idSelection);
            const request = new ApiServerRequest('/admin/companies/merge', { body: formData, method: 'POST' });
            try {
                const responseConstant = await apiFetchJson(request);
                const updated = [...companies].filter(v => v.id === responseConstant.id || idSelections.every((i => v.id !== i)));
                setCompanies(updated);
                resetRowSelection();
            }
            catch (error) {
                sendFetchError('Unable to merge companies', error, request);
                //
            }
            finally {
                setLoading(false);
            }
        }
    }, [apiFetchJson, companies, resetRowSelection, selection, setCompanies]);
    const onClickMerge = React.useCallback(() => {
        if (selection !== undefined && selection.length > 1) {
            (async () => await saveMerge())();
        }
    }, [saveMerge, selection]);
    return React.createElement(Button, { disabled: disabled, loading: isLoading, onClick: onClickMerge, size: "small", style: { marginLeft: '0.5rem' } }, "MERGE");
};
export default CompanyMergeButton;
